module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "confirmBox"
    }
  }, [_c('div', {
    staticClass: "confirm_container"
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.closeDialog
    }
  }), _vm._v(" "), _c('h2', [_vm._v("請確認信息")]), _vm._v(" "), _c('div', {
    staticClass: "infoBox"
  }, [_c('div', [_c('p', [_vm._v("報名會議：")]), _c('p', [_vm._v(_vm._s(_vm.meetingData.category_name))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("會議時間：")]), _c('p', [_vm._v(_vm._s(_vm.meetingData.meeting_year) + _vm._s(_vm.meetingData.meeting_time))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("會議城市：")]), _c('p', [_vm._v(_vm._s(_vm.meetingData.city_name))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("參會人數：")]), _c('p', [_vm._v(_vm._s(_vm.meetingPeople) + "位")])])]), _vm._v(" "), _c('p', {
    staticClass: "moneyTip"
  }, [_vm._v("參會費支付後概不退款")]), _vm._v(" "), _c('div', {
    staticClass: "join_fee"
  }, [_c('span', [_vm._v("參會費：")]), _c('em', [_vm._v("¥" + _vm._s(_vm.joinFee))])]), _vm._v(" "), _c('div', {
    staticClass: "confirm_btn",
    domProps: {
      "textContent": _vm._s(_vm.joinFee > 0 ? '確認並不支付' : '確認支付')
    },
    on: {
      "click": _vm.submitFn
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask_main"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-354ee030","hasScoped":false}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
// module id = 318
// module chunks = 1